import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_SCHOLARSHIP, CREATE_SCHOLARSHIP_ASSIGNMENT, CREATING_SCHOLARSHIP, CREATING_SCHOLARSHIP_ASSIGNMENT, DELETE_SCHOLARSHIP, DELETE_SCHOLARSHIP_ASSIGNMENT, DELETING_SCHOLARSHIP, DELETING_SCHOLARSHIP_ASSIGNMENT, GET_SCHOLARSHIP_ASSIGNMENTS, GET_SCHOLARSHIPS, GETTING_SCHOLARSHIP_ASSIGNMENTS, GETTING_SCHOLARSHIPS, SCHOLARSHIPS_ERROR, SET_SUCCESS, UPDATE_SCHOLARSHIP, UPDATING_SCHOLARSHIP } from "../types"

export const createScholarship = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_SCHOLARSHIP,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/scholarships`, payload, { headers })
        
        dispatch({
            type: CREATE_SCHOLARSHIP,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Scholarship created successfully'
        })
        
    }
    catch(error){
        dispatch({
            type: SCHOLARSHIPS_ERROR,
            error
        })
    }
}

export const updateScholarship = (id, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_SCHOLARSHIP,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/scholarships/${id}`, payload, { headers })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Scholarship updated successfull'
        })
        
        dispatch({
            type: UPDATE_SCHOLARSHIP,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: SCHOLARSHIPS_ERROR,
            error
        })
    }
}

export const deleteScholarship = (id) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: DELETING_SCHOLARSHIP,
            payload: true
        })

        const response = await axios.delete(`${baseUrl}/scholarships/${id}`, { headers })
        
        dispatch({
            type: DELETE_SCHOLARSHIP,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: SCHOLARSHIPS_ERROR,
            error
        })
    }
}

export const fetchScholarships = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/scholarships?expand=createdBy`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_SCHOLARSHIPS,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_SCHOLARSHIPS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: SCHOLARSHIPS_ERROR,
            error
        })
    }
}

export const clearCreatedScholarship = () => async (dispatch) => {    
    dispatch({
        type: CREATE_SCHOLARSHIP,
        payload: null
    })   
}

export const clearUpdatedScholarship = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_SCHOLARSHIP,
        payload: null
    })   
}

export const clearDeletedScholarship = () => async (dispatch) => {    
    dispatch({
        type: DELETE_SCHOLARSHIP,
        payload: null
    })   
}

export const createStudentScholarship = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_SCHOLARSHIP_ASSIGNMENT,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/student-scholarships`, payload, { headers })
        
        dispatch({
            type: CREATE_SCHOLARSHIP_ASSIGNMENT,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Scholarship assigned successfully'
        })
        
    }
    catch(error){
        dispatch({
            type: SCHOLARSHIPS_ERROR,
            error
        })
    }
}

export const clearCreatedStudentScholarship = () => async (dispatch) => {    
    dispatch({
        type: CREATE_SCHOLARSHIP_ASSIGNMENT,
        payload: null
    })   
}


export const deleteStudentScholarship = (id) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: DELETING_SCHOLARSHIP_ASSIGNMENT,
            payload: true
        })

        const response = await axios.delete(`${baseUrl}/student-scholarships/${id}`, { headers })
        
        dispatch({
            type: DELETE_SCHOLARSHIP_ASSIGNMENT,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: 'Student has been successfully removed as a beneficiary of this scholarshiip'
        })
        
    }
    catch(error){
        dispatch({
            type: SCHOLARSHIPS_ERROR,
            error
        })
    }
}

export const clearDeletedStudentScholarship = () => async (dispatch) => {    
    dispatch({
        type: DELETE_SCHOLARSHIP_ASSIGNMENT,
        payload: null
    })   
}



export const fetchStudentScholarships = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/student-scholarships?expand=createdBy,student,scholarship`

        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_SCHOLARSHIP_ASSIGNMENTS,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_SCHOLARSHIP_ASSIGNMENTS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: SCHOLARSHIPS_ERROR,
            error
        })
    }
}